/**
 * מלאי סניף משותף — ספירת מוצרים לפי ברקוד (גם במטמון מקומי / חיפוש לוקאלי).
 */

export function buildSharedBarcodeCountMap(products) {
  const map = new Map();
  for (const p of products || []) {
    const bc = String(p?.barcode ?? "").trim();
    if (!bc) continue;
    map.set(bc, (map.get(bc) || 0) + 1);
  }
  return map;
}

export function sharedBarcodeCountForBarcode(barcode, countMap) {
  const bc = String(barcode ?? "").trim();
  if (!bc) return 1;
  return countMap.get(bc) ?? 1;
}

/** מצרף shared_barcode_count לכל מוצר לפי כל המגוון */
export function enrichProductsWithSharedBarcodeCount(products, fullCatalog) {
  const catalog = fullCatalog?.length ? fullCatalog : products;
  const map = buildSharedBarcodeCountMap(catalog);
  return (products || []).map((p) => {
    const fromServer = Number(p?.shared_barcode_count ?? p?.sharedBarcodeCount ?? 0);
    const computed = sharedBarcodeCountForBarcode(p?.barcode, map);
    const count = fromServer > 1 ? fromServer : computed;
    return {
      ...p,
      shared_barcode_count: count,
      sharedBarcodeCount: count,
    };
  });
}

export function enrichPrefetchSnapshot(data) {
  if (!data?.products?.length) return data;
  const products = enrichProductsWithSharedBarcodeCount(data.products, data.products);
  const productsByCompany = {};
  for (const key of Object.keys(data.productsByCompany || {})) {
    productsByCompany[key] = enrichProductsWithSharedBarcodeCount(
      data.productsByCompany[key],
      data.products
    );
  }
  return { ...data, products, productsByCompany };
}
